import React, { memo, useState, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useGlobalFilter,
  useSortBy,
  useTable,
  usePagination,
} from "react-table";
import { FaTrashAlt } from "react-icons/fa";
import { GrFormPrevious, GrFormNext } from "react-icons/gr";
import Alert from "../Alert/Alert";
import Select from "react-select";

const CreationBoussole = memo(() => {
  const [boussoleModif, setBoussoleModif] = useState([]);
  const [boussole, setboussole] = useState([]);
  const [idSuppr, setIdSuppr] = useState();
  const [libelleEquipe, setLibelleEquipe] = useState();
  const [idSociette, setIdSociette] = useState("");

  //Fonctionnement de la page
  const [loadingboussole, setLoadingboussole] = useState([true]);
  const navigate = useNavigate();
  const params = useParams();
  const [showModal, setshowModal] = useState(false);
  const [listeCampagne, setListeCampagne] = useState();
  const [campagne, setCampagne] = useState([]);
  const [campagneError, setCampagneError] = useState("");

  const [showModalCamapgne, setShowModalCamapgne] = useState(false);

  const Campagne = async () => {
    const requestOptions = {
      method: "GET",
      header: {
        "Content-Type": "application:json",
      },
    };

    //liste des profils
    await fetch("/api/campagneBoussole/getCampagne", requestOptions)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        let objCampagne = data.map((campagne) => {
          return { value: campagne.id_campagne, label: campagne.nom };
        });
        setListeCampagne(objCampagne);

        // this.setState ({
        //     listeProfils: profils,
        // });
        // this.setState({loadingProfil : false});
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleChangeCampagne = (event) => {
    setCampagne(event);
  };

  const Validate = () => {
    
    //validation profil
    if (!campagne) {
      setCampagneError("La campagne doit être renseigné");
    }
  };

  useEffect(() => {
    Campagne();
  }, []);

  //equivalent de component did mount pour réalisé des action afin de charger la page avec les bonnes informations
  useEffect(() => {
    fetchBoussoleByEquipe();
    setBoussoleModif(false);
  }, [boussoleModif]);

  //Permet de récupérer les information de l'équipe
  const fetchEquipe = async () => {
    //Options de requete
    const body = {
      idEquipe: params.id,
    };

    const getByIdOptions = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    };

    fetch("/api/equipes/getEquipeById", getByIdOptions)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setIdSociette(data.ID_SOCIETE);
        setLibelleEquipe(data.LIBELLE_EQUIPE);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //import des Pulseur
  const fetchBoussoleByEquipe = async () => {
    const body = {
      idEquipe: params.id,
    };

    const requestOptions = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    };

    fetch("/api/boussole/getBoussoleByEquipe", requestOptions)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        
        setboussole(data);

        setLoadingboussole(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchBoussoleByEquipe();
    fetchEquipe();
  }, []);

  //Initilisation des éléments du tableau
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id_boussole",
      },
      {
        Header: "Date de création",
        accessor: "date_creation",
      },{
        Header: "Campagne",
        accessor: "nom",
      },
      {
        Header: "Identifiant Boussole",
        accessor: "id_boussole",
      },
    ],
    []
  );

  const Data = useMemo(() => [...boussole], [boussole]);

  const tableHooks = (hooks) => {
    hooks.visibleColumns.push((columns) => [
      ...columns.slice(1),
      {
        id: "Voir resultat",
        Header: "",
        Cell: ({ row }) => (
          <button
            className="text-white  p-1 m-1 flex hover:-translate-1 hover:scale-110 duration-300  hover:shadow-xl  rounded-lg bg-orange-incubate"
            onClick={() => {
              navigate(`/resultatBoussole/${row.values.id_boussole}`);
            }}
          >
            Voir resultat
          </button>
        ),
      },
      {
        id: "Supprimer",
        Header: "",
        Cell: ({ row }) => (
          <button onClick={() => boutonSuppr(row.values.id_boussole)}>
            <FaTrashAlt className="transition ease-in-out delay-150 hover:-translate-1 hover:scale-150 duration-300" />
          </button>
        ),
      },
    ]);
  };

  const tableInstance = useTable(
    {
      columns,
      data: Data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    tableHooks,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = tableInstance;

  //Fonction pour afficher le modal de supression
  function boutonSuppr(id) {
    setshowModal(true);
    setIdSuppr(id);
  }

  //Fonction de supression d'une boussole
  function Supprimer(event, id) {
    event.preventDefault();

    setBoussoleModif(true);
    setshowModal(false);

    const body = {
      idBoussole: id,
    };

    const requestOptions = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    };

    fetch("/api/boussole/delete", requestOptions)
      .then((res) => {
        if (res.status === 200) {
          alert("Boussole supprimé !");
        } else {
          alert("Erreur lors de la suppression...");
          throw new Error(res.error);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  //Fonction lancé par le bouton d'jaout et réalisant la création d'une boussole
  function onClick(event) {
    event.preventDefault();
    Validate()
    if (campagne.value !== "" && campagne.value !== undefined) {
      const body = {
        idEquipe: params.id,
        idCampagne: campagne.value,
      };

      const requestOptions = {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
        },
      };

      fetch("/api/boussole/", requestOptions)
        .then((res) => {
          if (res.status === 201) {
            alert("boussole créé avec succès !");
            setBoussoleModif(true);
            setShowModalCamapgne(false);
            setCampagne("");
          } else {
            alert("Erreur lors de la création de la boussole ...");
            throw new Error(res.error);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }

  //Fonction permetant de savoir si un numéro de ligne est pair ou non pour pouvoir modifier la couleur une ligne sur deux
  const isEven = (idx) => idx % 2 === 0;

  //Equivalent du render créant l'affichage
  if (loadingboussole) {
    return <h1> </h1>;
  } else {
    return (
      <div className="flex flex-col items-center justify-center h-full pt-32 ">
        <div className="justify-center inline-flex flex-col  pt-10 w-full px-8">
          <div className="flex flex-col mt-2 mb-2 items-center justify-center py-5">
            <h1 className="text-orange-incubate text-3xl ">
              Boussole de l'équipe: {libelleEquipe}
            </h1>
          </div>

          {/*table 1 */}

          <div className="w-screen lg:w-full px-5">
            <table
              className="text-left text-sm md:text-base w-full"
              {...getTableProps()}
            >
              <thead className="bg-orange-incubate text-xs text-white md:text-base">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        scope="col"
                        className="px-6 py-1"
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " ▼"
                            : " ▲"
                          : ""}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row, idx) => {
                  prepareRow(row);

                  return (
                    <tr
                      {...row.getRowProps()}
                      className={
                        "border-b hover:bg-orange-incubate hover:bg-opacity-50" +
                        (isEven(idx) ? " bg-orange-incubate bg-opacity-10" : "")
                      }
                    >
                      {row.cells.map((cell, _idx) => (
                        <td className="px-6 py-1" {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="pagination mt-2 flex flex-col md:flex-row items-center justify-center">
              <div>
                <button
                  onClick={() => previousPage()}
                  disabled={!canPreviousPage}
                >
                  <GrFormPrevious className="" />
                </button>
                <span>
                  <strong>
                    Page {pageIndex + 1} sur {pageOptions.length}
                  </strong>
                </span>
                <button onClick={() => nextPage()} disabled={!canNextPage}>
                  <GrFormNext className="" />
                </button>
              </div>
              <div className="md:ml-10">
                {"Nombre de questions par page "}
                <select
                  value={pageSize}
                  onChange={(e) => {
                    setPageSize(Number(e.target.value));
                  }}
                >
                  {[10, 30, 50].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      {pageSize}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center mt-5 md:mt-16 lg:mt-10 mb-5">
            <button
              type="button"
              className="transition ease-in-out delay-150 bg-orange-incubate hover:-translate-1 hover:scale-110 duration-300 font-bold text-lg py-2 px-3 mb-5 rounded-full text-white mx-2"
              onClick={() => {
                navigate(`/equipeBoussole/${idSociette}`); // probleme au niveau l'id ici l'id correspond a celui de l'equipe alors que l'on veut celui de la societte
              }}
            >
              Retour
            </button>
            <button
              type="button"
              className="transition ease-in-out delay-150 bg-orange-incubate hover:-translate-1 hover:scale-110 duration-300 font-bold text-lg py-2 px-3 mb-5 rounded-full text-white mx-2"
              onClick={() => setShowModalCamapgne(true)}
            >
              Créer une boussole
            </button>
          </div>
        </div>

        {/*Modal Suppr*/}

        {showModal ? (
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-auto my-6 mx-auto max-w-3xl">
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                    <h3 className="text-3xl font-semibold">ATTENTION</h3>
                  </div>
                  {/*body*/}
                  <div className="relative p-6 flex-auto">
                    <p className="my-4 text-slate-500 text-lg leading-relaxed">
                      Vous êtes sur le point de supprimer une boussole !
                      <br />
                      Etes vous sûr de vouloir continuer ?
                    </p>
                  </div>
                  <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                    <button
                      className="text-black background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => setshowModal(false)}
                    >
                      Annuler
                    </button>
                    <button
                      className="bg-red-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={(event) => Supprimer(event, idSuppr)}
                    >
                      Supprimer
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}

        {/*Modal Campagne*/}
        {showModalCamapgne ? (
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-auto my-6 mx-auto max-w-3xl">
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                    <h3 className="text-3xl font-semibold">Campagne</h3>
                  </div>
                  {/*body*/}
                  <div className="relative p-6 flex-auto">
                    <p className="my-4 text-slate-500 text-lg leading-relaxed">
                      Merci de choisir une campagne
                    </p>
                    <Select
                      aria-labelledby="Profil-label"
                      inputId="Profil-input"
                      name="Profil"
                      options={listeCampagne}
                      onChange={handleChangeCampagne}
                    />
                    {campagneError ? (
                      <div className="text-red-600">{campagneError}</div>
                    ) : null}
                  </div>

                  <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                    <button
                      className="text-black background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => setShowModalCamapgne(false)}
                    >
                      Annuler
                    </button>
                    <button
                      className="bg-red-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={onClick}
                    >
                      Creer Boussole
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}
      </div>
    );
  }
});

export default CreationBoussole;
